/** 18 pricing SKU keys — env: NUXT_PUBLIC_PRICING_<SKU_KEY_UPPER> */
export const PRICING_SKU_KEYS = [
  'small_one_time',
  'medium_one_time',
  'large_one_time',
  'ultra_one_time',
  'starter_monthly',
  'pro_small_monthly',
  'pro_medium_monthly',
  'pro_large_monthly',
  'ultra_small_monthly',
  'ultra_medium_monthly',
  'ultra_large_monthly',
  'starter_yearly',
  'pro_small_yearly',
  'pro_medium_yearly',
  'pro_large_yearly',
  'ultra_small_yearly',
  'ultra_medium_yearly',
  'ultra_large_yearly',
]

export function pricingSkuEnvVarName(skuKey) {
  return `NUXT_PUBLIC_PRICING_${skuKey.toUpperCase()}`
}

/** Build skuKey → productId map from NUXT_PUBLIC_PRICING_* env vars. */
export function readPricingProductIdsFromEnv(env = process.env) {
  /** @type {Record<string, string>} */
  const ids = {}
  for (const skuKey of PRICING_SKU_KEYS) {
    const value = env[pricingSkuEnvVarName(skuKey)]?.trim()
    if (value) ids[skuKey] = value
  }
  return ids
}
